<div class="widget-offers">
  <div class="unbeatable-flights">
    <div class="content-widget" [class.isMobile]="isMobile">
      <div class="header-widget" *ngIf="!isMobile">
        <div class="header-container">
          <app-ds-typography
            [size]="fontSize.XXXS"
            [text]="'OFFERS_FLIGHT.FROM' | transloco"
            [color]="fontColor.Secondary">
          </app-ds-typography>
          <div class="title">
            <app-ds-typography
              [size]="fontSize.MD"
              [text]="departurePlace.description"
              [color]="fontColor.Primary"
              [fontFamily]="fontFamily.SemiBold">
            </app-ds-typography>
          </div>
        </div>
        <div class="image">
          <img class="logo" loading="lazy" [src]="ilusTravel | ImageCdn"/>
        </div>
      </div>
      <div class="list-widget">
        <ng-container *ngFor="let item of flightOffers">
          <div class="item-widget" (click)="redirecTo(item)">
            <div class="item-left" *ngIf="!isMobile; else itemLeftMobile">
              <div class="item-date">
                <app-ds-typography
                  [size]="fontSize.XXS"
                  [text]="(formatDate(item.outbound) | titlecase) + ' - ' + (formatDate(item.inbound) | titlecase)"
                  [fontFamily]="fontFamily.SemiBold"
                  [color]="fontColor.Primary">
                </app-ds-typography>
              </div>
              <div class="item-flight" *ngIf="isDirectFlight(item.stops); else flightScale">
                <app-ds-typography
                  [size]="fontSize.XXXS"
                  [text]="'OFFERS_FLIGHT.DIRECT_FLIGHT' | transloco"
                  [color]="fontColor.Secondary">
                </app-ds-typography>
              </div>
              <ng-template #flightScale>  
                <div class="item-flight">
                  <app-ds-typography
                    [size]="fontSize.XXXS"
                    [text]="flightWithScale(item.stops) | transloco : { number: item.stops }"
                    [color]="fontColor.Secondary">
                  </app-ds-typography>
                </div>
              </ng-template>
            </div>
            <ng-template #itemLeftMobile>
              <div class="item-left">
                <div class="item-flight" *ngIf="isDirectFlight(item.stops); else flightScale">
                  <app-ds-typography
                    [size]="fontSize.XXXS"
                    [text]="'OFFERS_FLIGHT.DIRECT_FLIGHT' | transloco"
                    [color]="fontColor.Secondary">
                  </app-ds-typography>
                </div>
                <ng-template #flightScale>  
                  <div class="item-flight">
                    <app-ds-typography
                      [size]="fontSize.XXXS"
                      [text]="flightWithScale(item.stops) | transloco : { number: item.stops }"
                      [color]="fontColor.Secondary">
                    </app-ds-typography>
                  </div>
                </ng-template>
                <div class="item-date" *ngIf="isOneWay(item); else labelRoundTrip">
                  <app-ds-typography
                    [size]="fontSize.XXS"
                    [text]="formatDate(item.outbound) | titlecase"
                    [fontFamily]="fontFamily.SemiBold"
                    [color]="fontColor.Primary">
                  </app-ds-typography>
                </div>
                <ng-template #labelRoundTrip>  
                  <div class="item-date">
                    <app-ds-typography
                      [size]="fontSize.XXS"
                      [text]="(formatDate(item.outbound) | titlecase) + ' - ' + (formatDate(item.inbound) | titlecase)"
                      [fontFamily]="fontFamily.SemiBold"
                      [color]="fontColor.Primary">
                    </app-ds-typography>
                  </div>
                </ng-template>
              </div>
            </ng-template>
            <div class="item-right">
              <div class="item-content">
                <div class="item-text">
                  <app-ds-typography
                    [size]="fontSize.XXXS"
                    [text]="'OFFERS_FLIGHT.FROM' | transloco"
                    [color]="fontColor.Secondary">
                  </app-ds-typography>
                </div>
                <div class="item-price">
                  <app-ds-typography
                    [size]="fontSize.XXS"
                    [text]="item.bestprice | currencyFormat: item.currency"
                    [fontFamily]="fontFamily.SemiBold"
                    [color]="fontColor.Primary">
                  </app-ds-typography>
                </div>
              </div>
              <div class="button-link">
                <app-ds-icon
                  [size]="16"
                  [icon]="icons.ChevronRight"
                  [color]="iconColor.Primary">
                </app-ds-icon>
              </div>
            </div>
          </div>
          <div class="divider">
            <app-ds-divider></app-ds-divider>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>